export default {

  component: {
    jobAdList: {
      title: 'Avoimet työpaikat',
      jobs: 'työpaikat',
      noJobAds: 'Ei avoimia työpaikkoja tällä hetkellä.',
    },

    jobAdCard: {
      openUntil: date => `Hakuaika päättyy ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Kiitos.',
      readyInfo: 'Hakemuksesi on nyt tallennettu ja odottaa rekrytoijan käsittelyä.',
      luck: 'Onnea!',
    },

    jobAdSeeYou: {
      title: 'Kiitos',
      description: 'Hakemuksesi on nyt tallennettu. Olemme lähettäneet sähköpostiisi linkin, jonka kautta pääset nauhoittamaan videoesittelyn myöhemmin.',
    },

    unpublished: {
      title: 'Julkaisematon',
      info: 'Ilmoitusta ei ole vielä julkaistu.',
    },
  },

  page: {

  },

}
